import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Crown, User } from "lucide-react";

interface Props {
  image?: string;
  isManager?: boolean;
}

export const MemberAvatar = ({ image, isManager }: Props) => (
  <Avatar className="relative">
    <AvatarImage src={image ?? undefined} />
    <AvatarFallback>
      <User />
    </AvatarFallback>
    {isManager && <ManagerCrownIcon className="absolute -top-1 -right-1" />}
  </Avatar>
);

export const ManagerCrownIcon = ({ className }: { className?: string }) => {
  const { t } = useTranslation(["company"]);
  return (
    <div
      className={`bg-white rounded-full p-1 ${className}`}
      title={t("company:shared.team_manager")}
    >
      <Crown size={14} className="text-yellow-500" />
    </div>
  );
};
